/**
 * ICT (Information & Communication Technology) category config
 *
 * KPIs: totalComputersAvailableForStudents, noComputerLabs,
 *       interactiveTouchPanelinClassRoom, noOfSmartTV,
 *       internetConnectivity, internetType, internetPlan
 */
import type { CategoryConfig } from './CategoryConfig';

export const ictConfig: CategoryConfig = {
  categoryKey: 'ictProfile',
  label: 'ICT',
  priority: 8,

  columns: {
    defaultVisibleColumns: [
      'schoolName', 'stateName', 'roName',
      'totalComputersAvailableForStudents', 'noComputerLabs',
      'interactiveTouchPanelinClassRoom', 'noOfSmartTV',
      'internetConnectivity',
    ],
  },
};
